<template>
  <div>
    <div class="fin-news" v-if="!$route.params.id">
      <fin-content-section elevated>
        <template>
          <fin-tabs :tab-items="tabItems"
                    :background-color-tabs="$finColors.background"
                    background-color-tab-items="#FFFFFF">
            <template #0>
              <fin-news-overview/>
            </template>
            <template #1>
              <fin-newsticker/>
            </template>
            <template #2>
              <fin-my-news/>
            </template>
            <template #3>
              <fin-financial-calendar/>
            </template>
          </fin-tabs>
        </template>
      </fin-content-section>
    </div>
    <router-view v-else/>
  </div>
</template>

<script>
import FinMyNews from '@/components/pages/finNews/myNews/MyNews'
import FinNewsticker from '@/components/pages/finNews/newsticker/Newsticker'
import FinNewsOverview from '@/components/pages/finNews/overview/Overview'
import FinFinancialCalendar from '@/components/pages/finNews/financialCalendar/FinancialCalendar'
import FinTabs from "@/components/common/Tabs"
import FinContentSection from '@/components/pages/ContentSection'

export default {
  name: 'finNews',
  components: {
    FinTabs,
    FinFinancialCalendar,
    FinNewsOverview,
    FinNewsticker,
    FinMyNews,
    FinContentSection
  },
  data() {
    return {
      elevated: false,
      tabModel: 0,
      tabItems: [{name: "Überblick"}],
      hideNewstickerTab: process.env.VUE_APP_HIDE_NEWS_ALL === 'true' || process.env.VUE_APP_HIDE_NEWS_NEWSTICKER === 'true',
      hideMyNewsTab: process.env.VUE_APP_HIDE_NEWS_ALL === 'true' || process.env.VUE_APP_HIDE_NEWS_MYNEWS === 'true',
      hideFinanceCalendarTab: process.env.VUE_APP_HIDE_NEWS_ALL === 'true' || process.env.VUE_APP_HIDE_NEWS_FINANCE_CALENDAR === 'true'
    }
  },
  mounted() {
    if (!this.hideNewstickerTab) {
      this.tabItems.push({name: "Newsticker"})
    }
    if (!this.hideMyNewsTab) {
      this.tabItems.push({name: "Meine News"})
    }
    if (!this.hideFinanceCalendarTab) {
      this.tabItems.push({name: "Finanzkalendar"})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
